import location from './location';
import params from './params';

export function mailShare(subject, body) {
    subject = encodeURIComponent(subject?subject:'');
    body    = encodeURIComponent(body?body:'');
    window.open('mailto:?body='+body+" "+location()+'&subject='+subject, 'mailwindow', params);
};